<template>
  <div v-if="is_open" class="flex bg-transparent"
    :class="{
      'fixed-scolling fixed z-50 inset-0 w-sceen h-screen overflow-auto': show_as_window
    }"
  >

    <div class="p-5 h-fit bg-yellow-300"
         :class="{
          'max-w-3xl border sm:m-auto': show_as_window
         }"
    v-scroll-lock="is_open">
      <div class="flex justify-between mb-4">
        <h2>Test-Ergebnis senden</h2>
        <span v-if="show_as_window" @click="close_window" class="cursor-pointer close text-3xl">
          <i class="fa fa-times"></i>
        </span>
      </div>

      <p>
        Bitte tragen Sie hier <strong>Ihren</strong> Vornamen, Nachnamen sowie <strong>Ihre</strong> E-Mail Adresse ein.
      </p>

      <div class="mt-8">
        <div class="grid gap-2 grid-cols-2 sm:grid-cols-3">
          <label class="hidden sm:block">Vorname * / Nachname *</label>
          <input v-model="firstname" required placeholder="Vorname" type="text">
          <input v-model="lastname" required placeholder="Nachname" type="text">
        </div>
        <div class="grid gap-2 sm:grid-cols-3 mt-4">
          <label class="hidden sm:block">E-Mail *</label>
          <input v-model="email"
                 @keyup="email_ok = validate_email(email)"
                 required placeholder="E-Mail"
                 type="email"
                 class="col-span-2">
          <span v-if="!email_ok"></span>
          <span class="col-span-2 text-red-500 text-sm" v-if="!email_ok">
            Bitte geben Sie eine gültige E-Mail Adresse ein.
          </span>
        </div>
        <div class="grid gap-2 sm:grid-cols-3 mt-4">
          <label class="hidden sm:block">Telefon</label>
          <input v-model="telefon" placeholder="Telefon/Mobil" type="text" class="col-span-2">
        </div>

        <template v-if="with_consultants">
          <div class="mt-8 mb-4 font-medium">
            Bitte wählen Sie durch klicken Ihre Personalberatung ...
          </div>
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-4">
            <div v-for="( personal, idx ) in consultants"
                @click="select_consultant(personal)"
                :key="idx"
                class="hover:bg-gray-400 hover:text-white p-2  break-words cursor-pointer mt-2 flex flex-col text-center border-green-500"
                :class="{ 'bg-green-500 text-white hover:bg-green-400': selected_consultant == personal }">
              <span class="mb-1 text-sm">{{ personal.lastname }} {{ personal.firstname }}</span>
              <img :src="personal.image" class="object-cover">
              <span class="mt-1 text-sm break-words">
                {{ personal.email }}
              </span>
              <!-- {{ personal }} -->
            </div>
          </div>
        </template>

      </div>

      <div class="mt-4 flex justify-between items-center">
        <p class="text-sm w-4/6 p-0 m-0">
          Mit dem Absenden dieses Testergebnisses stimmen Sie zu, dass wir Ihre
          Daten für den Zeitraum der Weiterleitung kurzzeitig speichern.
        </p>

        <button class="px-4 py-2.5 text-white"
          :disabled="!input_data_valid"
          :class="{
            'bg-gray-300': !input_data_valid,
            'bg-green-500': input_data_valid
           }"
           @click="send_result">
          Ergebnis senden
        </button>

      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EventBus from '../api/event-bus'
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    subject_id: {
      type: String,
      required: true
    },
    show_as_window: {
      type: Boolean,
      default: false
    },
    with_consultants: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      is_open: true,
      firstname: null,
      lastname: null,
      telefon: null,
      email: null,
      selected_consultant: null,
      email_ok: true
    }
  },
  methods: {
    validate_email( email ) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    select_consultant( personal ) {
      this.selected_consultant = personal
    },
    close_window() {
      EventBus.emit( 'close-send-result-window')
    },
    async send_result() {

      if( !this.validate_email( this.email ) ) return

      const token = document.getElementsByName('csrf-token')[0].getAttribute('content')
      let testat = {
        department_id: this.current_department_id,
        subject_id: this.current_subject_id,
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        telefon: this.telefon,
        content: JSON.stringify( this.filtered_quiz_result( this.subject_id ) )
      }
      if (this.selected_consultant) {
        testat['consultant_id'] = this.selected_consultant.id
        testat['consultant_email'] = this.selected_consultant.email
      }

      await axios.post(`/api/v1/results.json`,
        { testat },
        { headers: {
          'Content-Type': 'application/json',
          'Credentials': 'same-origin',
          'Accept': 'application/json',
          'X-CSRF-Token': token,
        }
      }).then( result => {
        this.is_open = false
        this.close_window()
      }).catch( e => {
        // this.set_error()
      })

    }
  },
  computed: {
    ...mapState(['consultants', 'current_department_id', 'current_subject_id']),
    ...mapGetters(['filtered_quiz_result']),
    input_data_valid() {
      return ( this.selected_consultant || !this.with_consultants ) &&
             this.email > '' &&
             this.firstname > '' &&
             this.lastname > ''
    }
  }

}
</script>

<style scoped>
.h-fit {
  height: fit-content;
}
.fixed-scrolling {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>